export const EFltPaxType = {
   0: "UNKNOWN",
   1: "ADULT",
   2: "CHILD",
   3: "INFANT",
   4: "DISABLED",
   5: "DISABLED_COMPANION",
   6: "EXTRA_SEAT",
   "-1": "ALL",
};

export const EFltPaxSubType = {
   "-1": "ALL",
   0: "UNKNOWN",
   1: "VFR",
   2: "ITX",
   3: "LBR",
};

export const EFltCabinType = {
   0: "UNKNOWN",
   1: "ECONOMY",
   2: "BUSINESS",
   "-1": "ALL",
};

export const EFltTripType = {
   0: "UNKNOWN",
   1: "ONE_WAY",
   2: "ROUND_TRIP",
   3: "MULTI_LEG",
   "-1": "ALL",
};

export const EFltCountryType = {
   0: "UNKNOWN",
   1: "DOMESTIC",
   2: "INTERNATIONAL",
   "-1": "ALL",
};

export const EFltPnrStatus = {
   0: "UNKNOWN",
   1: "NEW",
   2: "RESERVED",
   3: "ISSUED",
   4: "CANCELED",
   5: "VOIDED",
   6: "REFUNDED",
   7: "REISSUED",
   8: "ERROR",
   9: "OPEN",
   10: "PENDING_ISSUED",
   11: "PENDING_RESERVED",
   12: "PENDING_CANCELED",
   13: "PENDING_VOIDED",
   14: "PENDING_REFUNDED",
   "-1": "ALL",
};

export const EFltPnrImportType = {
   0: "UNKNOWN",
   1: "AUTO",
   2: "MANUAL",
   3: "CRON",
   "-1": "ALL",
};

export const EFltEticketStatus = {
   0: "UNKNOWN",
   1: "NEW",
   2: "RESERVED",
   3: "ISSUED",
   4: "CANCELED",
   5: "VOIDED",
   6: "REFUNDED",
   7: "REISSUED",
   8: "ERROR",
   9: "OPEN",
   10: "PENDING_ISSUED",
   11: "PENDING_RESERVED",
   12: "PENDING_CANCELED",
   13: "PENDING_VOIDED",
   14: "PENDING_REFUNDED",
   "-1": "ALL",
};

export const EFltTicketUsageStatus = {
   0: "UNKNOWN",
   1: "FLOWN",
   2: "NOSHOW",
   "-1": "ALL",
};

export const EFltAncillaryStatus = {
   0: "UNKNOWN",
   1: "ISSUED",
   2: "REVERSED",
   3: "NEW",
   "-1": "ALL",
};

export const EFltAncillaryType = {
   1: "baggage",
   2: "seat",
   3: "meal",
   4: "wheelchair",
   5: "other",
   6: "airport-checkin",
   7: "reissue-allowance",
   8: "cabin-bag",
   9: "checkin-priority",
   10: "ravel-with-pet",
};

export const EFltFlightStatus = {
   0: "UNKNOWN",
   1: "ACTIVE",
   2: "REISSUED",
   3: "OPEN",
   4: "ERROR",
   "-1": "ALL",
};

export const EFltSegmentStatus = {
   0: "UNKNOWN",
   1: "ACTIVE",
   2: "REISSUED",
   3: "OPEN",
   4: "ERROR",
   "-1": "ALL",
};

export const EFltEticketTrxType = {
   0: "UNKNOWN",
   1: "SALE",
   2: "REVERSE",
   "-1": "ALL",
};

export const EFltPnrFlow = {
   0: "UNKNOWN",
   1: "RESERVE_AND_TICKET",
   2: "INSTANT_TICKET",
   "-1": "ALL",
};

export const EFltPnrIssueType = {
   0: "UNKNOWN",
   1: "RESERVE",
   2: "TICKET",
   "-1": "ALL",
};

export const EFltPnrReverseType = {
   0: "UNKNOWN",
   1: "CANCEL",
   2: "VOID",
   3: "REFUND",
   "-1": "ALL",
};

export const EFltPnrReverseEnabledType = {
   0: "UNKNOWN",
   1: "VOIDABLE",
   2: "REFUNDABLE_WO_PENALTY",
   3: "REFUNDABLE_WITH_PENALTY",
   4: "ALREADY_REVERSED",
   5: "UNREVERSABLE",
   6: "CANCELABLE",
   "-1": "ALL",
};

export const EFltAirportType = {
   0: "UNKNOWN",
   1: "AIRPORT",
   2: "CITY",
   "-1": "ALL",
};

export const EFltSearchType = {
   0: "UNKNOWN",
   1: "STANDART",
   2: "LAZYLOAD_PRE",
   3: "LAZYLOAD_POST",
   "-1": "ALL",
};

export const EFltSearchRuleSearchType = {
   0: "UNKNOWN",
   1: "OW_OW",
   2: "RT_OW",
   3: "RT_RT",
   4: "ML_OW",
   5: "ML_ML",
   "-1": "ALL",
};

export const EFltCommissionAmountType = {
   0: "UNKNOWN",
   1: "FIXED",
   2: "RATIO",
   "-1": "ALL",
};

export const EFltCommissionType = {
   0: "UNKNOWN",
   1: "GTS_SERVICE_FEE",
   2: "GSA_COMMISSION",
   3: "AGENCY_COMMISSION",
   4: "AGENCY_COMMISSION_EXTRA",
   5: "GSA_PROVIDER_COMMISSION",
   6: "GSA_PROVIDER_COMMISSION_EXTRA",
   7: "GSA_VPOS_COMMISSION",
   "-1": "ALL",
};

export const EFltReverseReason = {
   0: "UNKNOWN",
   1: "REASON_1",
   "-1": "ALL",
};

export const EFltIrregularAirline = {
   0: "UNKNOWN",
   99: "ANADOLUJET",
   "-1": "ALL",
};

export const EFltSsrType = {
   0: "UNKNOWN",
   1: "BAGGAGE",
   2: "SEAT",
   3: "MEAL",
   4: "WHEELCHAIR",
   5: "OTHER",
   6: "CHECKIN_AT_AIRPORT",
   7: "REISSUE_ALLOWANCE",
   8: "CABIN_BAG",
   9: "CHECKIN_PRIORITY",
   10: "RAVEL_WITH_PET",
   "-1": "ALL",
};

export const EFltSsrState = {
   0: "UNKNOWN",
   1: "INCLUDED",
   2: "NOT_INCLUDED",
};

export const EFltBaggageUnit = {
   0: "UNKNOWN",
   1: "KG",
   2: "PC",
   "-1": "ALL",
};

export const EFltBaggageType = {
   0: "UNKNOWN",
   1: "HAND_BAG",
   2: "CABIN_BAG",
   3: "CHECKED_BAG",
};

export const EFltPnrUserActionType = {
   0: "UNKNOWN",
   1: "INSERT",
   2: "UPDATE",
   3: "RESERVE",
   4: "TICKET",
   5: "REVERSE",
   "-1": "ALL",
};

export const EFltSsrMealType = {
   0: "UNKNOWN", // Unknown meal
   1: "HNML", // Hindu Meal
   2: "CHML", // Child Meal
   3: "MOML", // Moslem Meal
   4: "VGML", // Vegetarian Vegan Meal
   5: "CNML", // Chicken Meal
   6: "FSML", // Fish Meal
   7: "AVML", // Vegetarian Hindu Meal
   8: "BBML", // Baby Meal
   9: "BLML", // Bland Meal
   10: "DBML", // Diabetic Meal
   11: "FPML", // Fruit Platter Meal
   12: "GFML", // Gluten Intolerant Meal
   13: "KSML", // Kosher Meal
   14: "LCML", // Low Calorie Meal
   15: "LFML", // Low Fat Meal
   16: "LPML", // Low Protein Meal
   17: "LSML", // Meal without Salt
   18: "NLML", // Meal without Lactose
   19: "SFML", // Sea Food Meal
   20: "VJML", // Vegetarian Jain Meal
   21: "VLML", // Vegetarian Meal Lacto-Ovo
   22: "VOML", // Vegetarian Oriental Meal
   23: "SPML", // Special Meal

   100: "PRIBAS_SUN_PMID", //Kizarmis Citir Tavuk (international)
   101: "PRIBAS_SUN_PMIE", //Dana Gulas (international)
   102: "PRIBAS_SUN_PMIB", //Kahvalti Tabagi (international)
   103: "PRIBAS_SUN_PMIC", //Tavuk Sis Kebap (international)
   104: "PRIBAS_SUN_PMDD", //Kizarmis Citir Tavuk (domestic)
   105: "PRIBAS_SUN_PMDE", //Dana Gulas (domestic)
   106: "PRIBAS_SUN_PMDB", //Kahvalti Tabagi (domestic)
   107: "PRIBAS_SUN_PMDC", //Tavuk Sis Kebap (domestic)
   117: "PRIBAS_SUN_SPIB", //Sun Premium Omlet & 2 Icecek (international)
   118: "PRIBAS_SUN_SPIC", //Sun Premium Kofte & 2 Icecek (international)
   119: "PRIBAS_SUN_SPID", //Sun Premimum Patlican & 2 Icecek (international)
   120: "PRIBAS_SUN_SPIE", //Sun Premium Tavuk & 2 Icecek (international)
   121: "PRIBAS_SUN_SPDB", //Sun Premium Omlet & 2 Icecek (domestic)
   122: "PRIBAS_SUN_SPDC", //Sun Premium Kofte & 2 Icecek (domestic)
   123: "PRIBAS_SUN_SPDD", //Sun Premimum Patlican & 2 Icecek (domestic)
   124: "PRIBAS_SUN_SPDE", //Sun Premium Tavuk & 2 Icecek (domestic)
   125: "PRIBAS_SUN_SPVL", //Meze Tabagi (vejetaryen), 1 alkolsuz icecek
   126: "PRIBAS_SUN_SPVG", //Falafel (vegan), 1 alkolsuz icecek
   127: "PRIBAS_SUN_VGML", //Falafel (vegan)
   128: "PRIBAS_SUN_VLML", //Meze Tabagi (vejetaryen)
   129: "PRIBAS_SUN_SCSM", //SunClassic Snack Box
   130: "PRIBAS_SUN_CHML", //Cocuk Menusu

   // Pribas SunExpress Meal Types - FLIGHT-5529 ile eklenenler
   200: "PRIBAS_SUN_HBBI", // Peynirli Börekli Sıcak Kahvaltı
   201: "PRIBAS_SUN_HMSI", // Geleneksel Tavuk Şinitzel
   202: "PRIBAS_SUN_HMSD", // Geleneksel Tavuk Şinitzel
   203: "PRIBAS_SUN_HMGD", // Dana Gulaş
   204: "PRIBAS_SUN_HMGI", // Dana Gulaş
   205: "PRIBAS_SUN_CBFI", // Soğuk Kahvaltı Tabağı
   206: "PRIBAS_SUN_HBOI", // Omletli Sıcak Kahvaltı
   207: "PRIBAS_SUN_HMTI", // Geleneksel Tire Köftesi
   208: "PRIBAS_SUN_HMCI", // Soslu Tavuk
   209: "PRIBAS_SUN_HMTD", // Geleneksel Tire Köftesi
   210: "PRIBAS_SUN_HMCD", // Soslu Tavuk
   211: "PRIBAS_SUN_VLMI", // Meze Tabağı (Vejetaryen)
   212: "PRIBAS_SUN_VGMD", // Falafel (Vegan)
   213: "PRIBAS_SUN_VGMI", // Falafel (Vegan)
   214: "PRIBAS_SUN_VLMD", // Meze Tabağı
   215: "PRIBAS_SUN_CHMI", // Çocuk Menüsü
   216: "PRIBAS_SUN_TBML", // Atıştırmalık
   217: "PRIBAS_SUN_TAML", // Tatlı Atıştırmalık
   218: "PRIBAS_SUN_AFPI", // Pankek
   219: "PRIBAS_SUN_CAKD", // Kutlama Pastası
   220: "PRIBAS_SUN_CAKI", // Kutlama Pastası
   221: "PRIBAS_SUN_AFCI", // Karışık Kek ve Tatlı Seçkisi
   222: "PRIBAS_SUN_HMAI", // Geleneksel Adana Kebap
   223: "PRIBAS_SUN_HMAD", // Geleneksel Adana Kebap
   224: "PRIBAS_SUN_AFCD", // Karışık Kek ve Tatlı Seçkisi
   225: "PRIBAS_SUN_HBBD", // Peynirli Börekli Sıcak Kahvaltı
   226: "PRIBAS_SUN_HMPD", // Akdeniz Usulü Penne
   227: "PRIBAS_SUN_HMMD", // Peynirli Makarna
   228: "PRIBAS_SUN_CBFD", // Soğuk Kahvaltı Tabağı
   229: "PRIBAS_SUN_AFPD", // Pankek
   230: "PRIBAS_SUN_CHMD", // Çocuk Menüsü
   231: "PRIBAS_SUN_HMMI", // Peynirli Makarna
   232: "PRIBAS_SUN_HMPI", // Akdeniz Usulü Penne

   300: "PEGASUS_NDC_PSIM", //Beyaz Peynirli Tahilli Simit
   301: "PEGASUS_NDC_BBML", //Bebek Yemegi //Standart Kodlarda var zaten
   302: "PEGASUS_NDC_BLML", //Hafif Yemek //Standart Kodlarda var zaten
   303: "PEGASUS_NDC_DBML", //Diyabetik Yemek //Standart Kodlarda var zaten
   304: "PEGASUS_NDC_GFML", //Glutensiz Yemek //Standart Kodlarda var zaten
   305: "PEGASUS_NDC_HMCH", //Tavuk Sinitzel
   306: "PEGASUS_NDC_HMPA", //Ravyoli
   307: "PEGASUS_NDC_KSML", //Koser Yemegi //Standart Kodlarda var zaten
   308: "PEGASUS_NDC_LCML", //Dusuk Kalorili Yemek //Standart Kodlarda var zaten
   309: "PEGASUS_NDC_LFML", //Az Yagli Yemek //Standart Kodlarda var zaten
   310: "PEGASUS_NDC_LSML", //Az Tuzlu Menu //Standart Kodlarda var zaten
   311: "PEGASUS_NDC_MLKF", //Izgara Kofte
   312: "PEGASUS_NDC_MLTA", //Firinda Tavuk Budu
   313: "PEGASUS_NDC_MOML", //Musluman Yemegi //Standart Kodlarda var zaten
   314: "PEGASUS_NDC_NLML", //Laktozsuz Yemek //Standart Kodlarda var zaten
   315: "PEGASUS_NDC_NODL", //Noodle
   316: "PEGASUS_NDC_PFML", //Fistiksiz Menu
   317: "PEGASUS_NDC_SFML", //Deniz Urunleri //Standart Kodlarda var zaten
   318: "PEGASUS_NDC_VGML", //Vejeteryan Yemegi //Pribas'ta girilmis
   319: "PEGASUS_NDC_CHMB", //Cocuk Menusu
   320: "PEGASUS_NDC_BPSW", //Peynirli Sandvic
   321: "PEGASUS_NDC_GFSW", //Glutensiz Sandvic
   322: "PEGASUS_NDC_JASW", //Jambonlu Sandvic
   323: "PEGASUS_NDC_KFSW", //Kofteli Sandvic
   324: "PEGASUS_NDC_PEWR", //Sebzeli&Peynirli Durum
   325: "PEGASUS_NDC_PEYS", //Peynirli Kuru Domatesli Sandvic
   326: "PEGASUS_NDC_TASW", //Tavuklu Sandvic
   327: "PEGASUS_NDC_TAWR", //Tavuk Durum
   328: "PEGASUS_NDC_TONS", //Ton Balikli Sandvic
   329: "PEGASUS_NDC_TOST", //Tost
   330: "PEGASUS_NDC_VGWR", //Vegan Sandvic
   331: "PEGASUS_NDC_SLDA", //Akdeniz Salata
   332: "PEGASUS_NDC_SLDC", //Tavuklu Sezar Salata
   333: "PEGASUS_NDC_SLDK", //Kinoa Salata
   334: "PEGASUS_NDC_CBRA", //Soguk Kahvalti
   335: "PEGASUS_NDC_CBRF", //Light Kahvalti
   336: "PEGASUS_NDC_HBRA", //Sicak Kahvalti
   337: "PEGASUS_NDC_SLDF", //Meyve Salatasi

   338: "PEGASUS_NDC_PIZA", //Pizza Slice
   339: "PEGASUS_NDC_PNCK", //Pancake
   340: "PEGASUS_NDC_GRNB", //Granola with Berry Souce
   341: "PEGASUS_NDC_GRNS", //Granola with Strawberry Yogurt
   342: "PEGASUS_NDC_BOWL", //Chicken Bowl
   343: "PEGASUS_NDC_MCCH", //Mac & Cheese
   344: "PEGASUS_NDC_BEEF", //Beef Brochette
   345: "PEGASUS_NDC_FING", //Chicken Fingers & Sauteed Potatoes
   346: "PEGASUS_NDC_LSNG", //Lasagna
   347: "PEGASUS_NDC_OMLT", //Omelette with Cheese & Sautéed Potatoes
   348: "PEGASUS_NDC_CHPL", //Cheese Plate
   349: "PEGASUS_NDC_SPCC", //Celebration Cake
   350: "PEGASUS_NDC_BDAY", //Sacher Torte
   351: "PEGASUS_NDC_EKSW", //Sandvic With Old Cheddar
   352: "PEGASUS_NDC_KRVP", //Croissant With Mozzarella
   353: "PEGASUS_NDC_DNWR", //Doner Wrapper
   354: "PEGASUS_NDC_BRYN", //Chicken Biryani
   355: "PEGASUS_NDC_LVRK", //Grilled Seabass
   356: "PEGASUS_NDC_DSRA", //Fondue With Chocolate Sauce
   357: "PEGASUS_NDC_CBRB", //Breakfast With Borek

   "-1": "ALL", // All meals
};

export const EFltSsrMealTypeReverse = {
   ALL: "-1", // All meals
   UNKNOWN: 0, // Unknown meal
   HNML: 1, // Hindu Meal
   CHML: 2, // Child Meal
   MOML: 3, // Moslem Meal
   VGML: 4, // Vegetarian Vegan Meal
   CNML: 5, // Chicken Meal
   FSML: 6, // Fish Meal
   AVML: 7, // Vegetarian Hindu Meal
   BBML: 8, // Baby Meal
   BLML: 9, // Bland Meal
   DBML: 10, // Diabetic Meal
   FPML: 11, // Fruit Platter Meal
   GFML: 12, // Gluten Intolerant Meal
   KSML: 13, // Kosher Meal
   LCML: 14, // Low Calorie Meal
   LFML: 15, // Low Fat Meal
   LPML: 16, // Low Protein Meal
   LSML: 17, // Meal without Salt
   NLML: 18, // Meal without Lactose
   SFML: 19, // Sea Food Meal
   VJML: 20, // Vegetarian Jain Meal
   VLML: 21, // Vegetarian Meal Lacto-Ovo
   VOML: 22, // Vegetarian Oriental Meal
   SPML: 23, // Special Meal

   PRIBAS_SUN_PMID: 100, //Kizarmis Citir Tavuk (international)
   PRIBAS_SUN_PMIE: 101, //Dana Gulas (international)
   PRIBAS_SUN_PMIB: 102, //Kahvalti Tabagi (international)
   PRIBAS_SUN_PMIC: 103, //Tavuk Sis Kebap (international)
   PRIBAS_SUN_PMDD: 104, //Kizarmis Citir Tavuk (domestic)
   PRIBAS_SUN_PMDE: 105, //Dana Gulas (domestic)
   PRIBAS_SUN_PMDB: 106, //Kahvalti Tabagi (domestic)
   PRIBAS_SUN_PMDC: 107, //Tavuk Sis Kebap (domestic)

   PRIBAS_SUN_SPIB: 117, //Sun Premium Omlet & 2 Icecek (international)
   PRIBAS_SUN_SPIC: 118, //Sun Premium Kofte & 2 Icecek (international)
   PRIBAS_SUN_SPID: 119, //Sun Premimum Patlican & 2 Icecek (international)
   PRIBAS_SUN_SPIE: 120, //Sun Premium Tavuk & 2 Icecek (international)
   PRIBAS_SUN_SPDB: 121, //Sun Premium Omlet & 2 Icecek (domestic)
   PRIBAS_SUN_SPDC: 122, //Sun Premium Kofte & 2 Icecek (domestic)
   PRIBAS_SUN_SPDD: 123, //Sun Premimum Patlican & 2 Icecek (domestic)
   PRIBAS_SUN_SPDE: 124, //Sun Premium Tavuk & 2 Icecek (domestic)

   PRIBAS_SUN_SPVL: 125, //Meze Tabagi (vejetaryen), 1 alkolsuz icecek
   PRIBAS_SUN_SPVG: 126, //Falafel (vegan), 1 alkolsuz icecek

   PRIBAS_SUN_VGML: 127, //Falafel (vegan)
   PRIBAS_SUN_VLML: 128, //Meze Tabagi (vejetaryen)
   PRIBAS_SUN_SCSM: 129, //SunClassic Snack Box
   PRIBAS_SUN_CHML: 130, //Cocuk Menusu

   // Pribas SunExpress Meal Types - FLIGHT-5529 ile eklenenler
   PRIBAS_SUN_HBBI: 200, // Peynirli Börekli Sıcak Kahvaltı
   PRIBAS_SUN_HMSI: 201, // Geleneksel Tavuk Şinitzel
   PRIBAS_SUN_HMSD: 202, // Geleneksel Tavuk Şinitzel
   PRIBAS_SUN_HMGD: 203, // Dana Gulaş
   PRIBAS_SUN_HMGI: 204, // Dana Gulaş
   PRIBAS_SUN_CBFI: 205, // Soğuk Kahvaltı Tabağı
   PRIBAS_SUN_HBOI: 206, // Omletli Sıcak Kahvaltı
   PRIBAS_SUN_HMTI: 207, // Geleneksel Tire Köftesi
   PRIBAS_SUN_HMCI: 208, // Soslu Tavuk
   PRIBAS_SUN_HMTD: 209, // Geleneksel Tire Köftesi
   PRIBAS_SUN_HMCD: 210, // Soslu Tavuk
   PRIBAS_SUN_VLMI: 211, // Meze Tabağı (Vejetaryen)
   PRIBAS_SUN_VGMD: 212, // Falafel (Vegan)
   PRIBAS_SUN_VGMI: 213, // Falafel (Vegan)
   PRIBAS_SUN_VLMD: 214, // Meze Tabağı
   PRIBAS_SUN_CHMI: 215, // Çocuk Menüsü
   PRIBAS_SUN_TBML: 216, // Atıştırmalık
   PRIBAS_SUN_TAML: 217, // Tatlı Atıştırmalık
   PRIBAS_SUN_AFPI: 218, // Pankek
   PRIBAS_SUN_CAKD: 219, // Kutlama Pastası
   PRIBAS_SUN_CAKI: 220, // Kutlama Pastası
   PRIBAS_SUN_AFCI: 221, // Karışık Kek ve Tatlı Seçkisi
   PRIBAS_SUN_HMAI: 222, // Geleneksel Adana Kebap
   PRIBAS_SUN_HMAD: 223, // Geleneksel Adana Kebap
   PRIBAS_SUN_AFCD: 224, // Karışık Kek ve Tatlı Seçkisi
   PRIBAS_SUN_HBBD: 225, // Peynirli Börekli Sıcak Kahvaltı
   PRIBAS_SUN_HMPD: 226, // Akdeniz Usulü Penne
   PRIBAS_SUN_HMMD: 227, // Peynirli Makarna
   PRIBAS_SUN_CBFD: 228, // Soğuk Kahvaltı Tabağı
   PRIBAS_SUN_AFPD: 229, // Pankek
   PRIBAS_SUN_CHMD: 230, // Çocuk Menüsü
   PRIBAS_SUN_HMMI: 231, // Peynirli Makarna
   PRIBAS_SUN_HMPI: 232, // Akdeniz Usulü Penne

   PEGASUS_NDC_PSIM: 300, //Beyaz Peynirli Tahilli Simit
   PEGASUS_NDC_BBML: 301, //Bebek Yemegi //Standart Kodlarda var zaten
   PEGASUS_NDC_BLML: 302, //Hafif Yemek //Standart Kodlarda var zaten
   PEGASUS_NDC_DBML: 303, //Diyabetik Yemek //Standart Kodlarda var zaten
   PEGASUS_NDC_GFML: 304, //Glutensiz Yemek //Standart Kodlarda var zaten
   PEGASUS_NDC_HMCH: 305, //Tavuk Sinitzel
   PEGASUS_NDC_HMPA: 306, //Ravyoli
   PEGASUS_NDC_KSML: 307, //Koser Yemegi //Standart Kodlarda var zaten
   PEGASUS_NDC_LCML: 308, //Dusuk Kalorili Yemek //Standart Kodlarda var zaten
   PEGASUS_NDC_LFML: 309, //Az Yagli Yemek //Standart Kodlarda var zaten
   PEGASUS_NDC_LSML: 310, //Az Tuzlu Menu //Standart Kodlarda var zaten
   PEGASUS_NDC_MLKF: 311, //Izgara Kofte
   PEGASUS_NDC_MLTA: 312, //Firinda Tavuk Budu
   PEGASUS_NDC_MOML: 313, //Musluman Yemegi //Standart Kodlarda var zaten
   PEGASUS_NDC_NLML: 314, //Laktozsuz Yemek //Standart Kodlarda var zaten
   PEGASUS_NDC_NODL: 315, //Noodle
   PEGASUS_NDC_PFML: 316, //Fistiksiz Menu
   PEGASUS_NDC_SFML: 317, //Deniz Urunleri //Standart Kodlarda var zaten
   PEGASUS_NDC_VGML: 318, //Vejeteryan Yemegi //Pribas'ta girilmis
   PEGASUS_NDC_CHMB: 319, //Cocuk Menusu
   PEGASUS_NDC_BPSW: 320, //Peynirli Sandvic
   PEGASUS_NDC_GFSW: 321, //Glutensiz Sandvic
   PEGASUS_NDC_JASW: 322, //Jambonlu Sandvic
   PEGASUS_NDC_KFSW: 323, //Kofteli Sandvic
   PEGASUS_NDC_PEWR: 324, //Sebzeli&Peynirli Durum
   PEGASUS_NDC_PEYS: 325, //Peynirli Kuru Domatesli Sandvic
   PEGASUS_NDC_TASW: 326, //Tavuklu Sandvic
   PEGASUS_NDC_TAWR: 327, //Tavuk Durum
   PEGASUS_NDC_TONS: 328, //Ton Balikli Sandvic
   PEGASUS_NDC_TOST: 329, //Tost
   PEGASUS_NDC_VGWR: 330, //Vegan Sandvic
   PEGASUS_NDC_SLDA: 331, //Akdeniz Salata
   PEGASUS_NDC_SLDC: 332, //Tavuklu Sezar Salata
   PEGASUS_NDC_SLDK: 333, //Kinoa Salata
   PEGASUS_NDC_CBRA: 334, //Soguk Kahvalti
   PEGASUS_NDC_CBRF: 335, //Light Kahvalti
   PEGASUS_NDC_HBRA: 336, //Sicak Kahvalti
   PEGASUS_NDC_SLDF: 337, //Meyve Salatasi

   PEGASUS_NDC_PIZA: 338, //Pizza Slice
   PEGASUS_NDC_PNCK: 339, //Pancake
   PEGASUS_NDC_GRNB: 340, //Granola with Berry Souce
   PEGASUS_NDC_GRNS: 341, //Granola with Strawberry Yogurt
   PEGASUS_NDC_BOWL: 342, //Chicken Bowl
   PEGASUS_NDC_MCCH: 343, //Mac & Cheese
   PEGASUS_NDC_BEEF: 344, //Beef Brochette
   PEGASUS_NDC_FING: 345, //Chicken Fingers & Sauteed Potatoes
   PEGASUS_NDC_LSNG: 346, //Lasagna
   PEGASUS_NDC_OMLT: 347, //Omelette with Cheese & Sautéed Potatoes
   PEGASUS_NDC_CHPL: 348, //Cheese Plate
   PEGASUS_NDC_SPCC: 349, //Celebration Cake
   PEGASUS_NDC_BDAY: 350, //Sacher Torte
   PEGASUS_NDC_EKSW: 351, //Sandvic With Old Cheddar
   PEGASUS_NDC_KRVP: 352, //Croissant With Mozzarella
   PEGASUS_NDC_DNWR: 353, //Doner Wrapper
   PEGASUS_NDC_BRYN: 354, //Chicken Biryani
   PEGASUS_NDC_LVRK: 355, //Grilled Seabass
   PEGASUS_NDC_DSRA: 356, //Fondue With Chocolate Sauce
   PEGASUS_NDC_CBRB: 357, //Breakfast With Borek

   PEGASUS_NDC_TASC: 433, //Tavuklu Sezar Salata
   PEGASUS_NDC_MLKC: 434, //Izgara Köfte
   PEGASUS_NDC_HMCC: 435, //Tavuk Şinitzel
};

export const EFltSsrWheelchairType = {
   0: "UNKNOWN",
   1: "WCHC", // Wheelchair (Pax completely immobile and cannot climb stairs)
   2: "WCHR", // Wheelchair for the Ramp. (Can climb stairs.)
   3: "WCHS", // Wheelchair (Can't climb stairs.)
   4: "WCBD", // Dry Cell battery operated wheelchair
   5: "WCMP", // Wheelchair Manuel (Power Driven)
   6: "WCLB", // Passenger who has own Lithium Battery powered wheelchair
   "-1": "ALL",
};

export const EFltSsrWheelchairTypeReverse = {
   ALL: -1,
   UNKNOWN: 0,
   WCHC: 1, // Wheelchair (Pax completely immobile and cannot climb stairs)
   WCHR: 2, // Wheelchair for the Ramp. (Can climb stairs.)
   WCHS: 3, // Wheelchair (Can't climb stairs.)
   WCBD: 4, // Dry Cell battery operated wheelchair
   WCMP: 5, // Wheelchair Manuel (Power Driven)
   WCLB: 6, // Passenger who has own Lithium Battery powered wheelchair
};

export const EFltPnrCcCheckStatus = {
   0: "UNKNOWN",
   1: "UNCHECKED",
   2: "CHECKED",
   "-1": "ALL",
};

export const EFltReportDateType = {
   0: "UNKNOWN",
   1: "FLIGHT_DATE",
   "-1": "ALL",
};

export const EFltWarnType = {
   0: "UNKNOWN",
   1: "INFO",
   2: "FLIGHT_TIME_CHANGED",
   3: "SEGMENT_CLASS_CHANGED",
   4: "SEGMENT_CABIN_CHANGED",
   5: "LEG_COUNT_CHANGED",
   6: "PRICE_UNAVAILABLE",
   7: "BAGGAGE_ALLOWANCE_CHANGED",
   "-1": "PRICE_UNAVAILABLE",
};

export const EFltReissueAvailType = {
   0: "UNKNOWN",
   1: "NOT_AVAILABLE",
   2: "ONLY_OW",
   3: "ONLY_RT",
   4: "ONLY_ML",
   5: "BOTH_RT_OW",
   6: "BOTH_ML_OW",
};

export const EFltFlightTimeTableStatus = {
   0: "UNKNOWN",
   1: "NO_INFO",
   2: "VALID_ROUTES",
   "-1": "ALL",
};

export const EFltSeatStatus = {
   0: "UNKNOWN",
   1: "AVAILABLE",
   2: "NOT_AVAILABLE",
   "-1": "ALL",
};

export const EFltSeatType = {
   0: "UNKNOWN",
   1: "AISLE",
   2: "WINDOW",
   3: "STANDARD",
   4: "EXIT",
   5: "PRIORITY",
   6: "EXTRA_LEGROOM",
   7: "WING",
   "-1": "ALL",
};

export const EFltSeatLayout = {
   0: "UNKNOWN",
   1: "SL_1_1",
   2: "SL_1_2",
   3: "SL_2_2",
   4: "SL_3_3",
   5: "SL_1_1_1",
   6: "SL_1_2_1",
   7: "SL_2_2_2",
   8: "SL_2_3_2",
   9: "SL_2_4_2",
   10: "SL_3_3_3",
   11: "SL_3_4_3",
   "-1": "ALL",
};

export const EFltEticketNoShowStatus = {
   0: "UNKNOWN",
   1: "OPEN",
   2: "SUCCESS",
   3: "FAILED",
   "-1": "ALL",
};
